import { FormGroupHeader } from "@/components/shared";
import { useTranslation } from "react-i18next";
import { FetchBillingQuery, FetchBillingDocument, FetchBillingQueryVariables } from "@/graphql/__generated__/graphql";
import ContractDetails from "./ContractDetails";
import { useQuery } from "@apollo/client/react";

function BillingComponent() {
  const { t } = useTranslation();

  const { data: billingData, loading: billingLoading } = useQuery<FetchBillingQuery, FetchBillingQueryVariables>(FetchBillingDocument, {
    fetchPolicy: "cache-and-network"
  });

  const billing = billingData?.fetchBilling;

  return (
    <div className="pb-[300px]">
      <FormGroupHeader
        className="pr-4 pl-2"
        title={t("settings.billing.title")}
        description={t("settings.billing.description")}
      />

      <div className="pr-4 pl-2">
        <ContractDetails billing={billing} billingLoading={billingLoading} />
      </div>
    </div>
  );
}

export default BillingComponent;
